// src/redux/Rent/rent.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/api';

const err = (e) => e?.response?.data || e?.message;

export const fetchRentLooking = createAsyncThunk('rent/fetchRentLooking', async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get('rents/web/looking_for', { signal }); return r.data.data; }
  catch (e) { return rejectWithValue(err(e)); }
});

export const fetchJobLooking = createAsyncThunk('rent/fetchJobLooking', async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get('jobs/web/looking_for', { signal }); return r.data.data; }
  catch (e) { return rejectWithValue(err(e)); }
});

const initialState = {
  rentData: null,
  jobData: null,
  savedDataRent: null,
  savedDataJob: null,
  postedRent: null,
  postedJob: null,
  rentStatus: 'idle',
  jobStatus: 'idle',
  error: null
};

const rentRedux = createSlice({
  name: 'rent',
  initialState,
  reducers: {
    setSavedDataProfile: (state, actions) => { state.savedDataRent = actions.payload; },
    setSavedJobData: (state, actions) => { state.savedDataJob = actions.payload; },
    setPostedRent: (state, actions) => { state.postedRent = actions.payload; },
    setPostedJob: (state, actions) => { state.postedJob = actions.payload; }
  },
  extraReducers: (b) => {
    b.addCase(fetchRentLooking.pending, (s) => { s.rentStatus = 'loading'; s.error = null; })
     .addCase(fetchRentLooking.fulfilled, (s, a) => { s.rentStatus = 'succeeded'; s.rentData = a.payload; })
     .addCase(fetchRentLooking.rejected, (s, a) => { s.rentStatus = 'failed'; s.error = a.payload || a.error.message; })
     .addCase(fetchJobLooking.pending, (s) => { s.jobStatus = 'loading'; s.error = null; })
     .addCase(fetchJobLooking.fulfilled, (s, a) => { s.jobStatus = 'succeeded'; s.jobData = a.payload; })
     .addCase(fetchJobLooking.rejected, (s, a) => { s.jobStatus = 'failed'; s.error = a.payload || a.error.message; });
  }
});

export const rentState = (state) => state.rent;
export const { setSavedDataProfile, setSavedJobData, setPostedRent, setPostedJob } = rentRedux.actions;
export default rentRedux.reducer;
